module.exports = __webpack_public_path__ + "static/media/client5.4c53834e.jpg";